import { EmailDesign } from "@/stores/emailBuilderStore";

export const DefaultNewRecurringScheduleEmail = (design: EmailDesign) => {
    return {
        page: {
            body: {
                container: {
                    style: {
                        "background-color": "#FFFFFF",
                    },
                },
                content: {
                    computedStyle: {
                        align: "center",
                        linkColor: "#0015ADE8",
                        messageBackgroundColor: "transparent",
                        messageWidth: "600px",
                    },
                    style: {
                        color: "#000000",
                        "font-family":
                            "'Helvetica Neue', Helvetica, Arial, sans-serif",
                    },
                },
                webFonts: [],
            },
            description: "",
            rows: [
                {
                    columns: [
                        {
                            "grid-columns": 12,
                            modules: [
                                {
                                    descriptor: {
                                        computedStyle: {
                                            hideContentOnAmp: false,
                                            hideContentOnDesktop: false,
                                            hideContentOnHtml: false,
                                            hideContentOnMobile: false,
                                        },
                                        html: {
                                            html: `<img src="${design.logoUrl}" alt="Organization Logo" style="width:25%;" />`,
                                        },
                                        style: {
                                            "padding-bottom": "0px",
                                            "padding-left": "0px",
                                            "padding-right": "0px",
                                            "padding-top": "0px",
                                        },
                                    },
                                    locked: false,
                                    type: "mailup-bee-newsletter-modules-html",
                                    uuid: "5a5ace0a-8742-4739-8f76-ece13ed26554",
                                },
                            ],
                            style: {
                                "background-color": "transparent",
                                "border-bottom": "0px solid transparent",
                                "border-left": "0px solid transparent",
                                "border-right": "0px solid transparent",
                                "border-top": "0px solid transparent",
                                "padding-bottom": "5px",
                                "padding-left": "0px",
                                "padding-right": "0px",
                                "padding-top": "35px",
                            },
                            uuid: "4b56e053-2715-432e-8a3d-ee3123d880cb",
                        },
                    ],
                    container: {
                        style: {
                            "background-color": "transparent",
                            "background-image": "none",
                            "background-position": "top left",
                            "background-repeat": "no-repeat",
                        },
                    },
                    content: {
                        computedStyle: {
                            hideContentOnDesktop: false,
                            hideContentOnMobile: false,
                            rowColStackOnMobile: true,
                            rowReverseColStackOnMobile: false,
                            verticalAlign: "top",
                        },
                        style: {
                            "background-color": "transparent",
                            "background-image": "none",
                            "background-position": "top left",
                            "background-repeat": "no-repeat",
                            "border-bottom": "0px solid transparent",
                            "border-left": "0px solid transparent",
                            "border-radius": "0px",
                            "border-right": "0px solid transparent",
                            "border-top": "0px solid transparent",
                            color: "#000000",
                            width: "600px",
                        },
                    },
                    empty: false,
                    locked: false,
                    synced: false,
                    type: "one-column-empty",
                    uuid: "3826388b-4c0d-4424-b182-557c5bfd5eff",
                },
                {
                    columns: [
                        {
                            "grid-columns": 12,
                            modules: [
                                {
                                    descriptor: {
                                        computedStyle: {
                                            hideContentOnMobile: false,
                                        },
                                        style: {
                                            "padding-bottom": "0px",
                                            "padding-left": "30px",
                                            "padding-right": "30px",
                                            "padding-top": "25px",
                                        },
                                        text: {
                                            computedStyle: {
                                                linkColor: "#0015ADE8",
                                            },
                                            html: '<div class="txtTinyMce-wrapper" style="font-size:14px;line-height:16px;font-family:inherit;" data-mce-style="font-size:14px;line-height:16px;font-family:inherit;"><p style="font-size:14px;line-height:16px;word-break:break-word;" data-mce-style="font-size:14px;line-height:16px;word-break:break-word;"><span style="font-size:26px;line-height:31px;" data-mce-style="font-size:26px;line-height:31px;">Thanks for setting up a recurring gift!</span></p></div>',
                                            style: {
                                                color: "#333333",
                                                "font-family": "inherit",
                                                "line-height": "120%",
                                            },
                                        },
                                    },
                                    locked: false,
                                    type: "mailup-bee-newsletter-modules-text",
                                    uuid: "8ca40376-c1f8-4876-b0ea-2e1075eb010f",
                                },
                                {
                                    descriptor: {
                                        computedStyle: {
                                            align: "center",
                                            hideContentOnMobile: false,
                                        },
                                        divider: {
                                            style: {
                                                "border-top":
                                                    "1px solid #DADADA",
                                                width: "100%",
                                            },
                                        },
                                        style: {
                                            "padding-bottom": "25px",
                                            "padding-left": "0px",
                                            "padding-right": "0px",
                                            "padding-top": "40px",
                                        },
                                    },
                                    locked: false,
                                    type: "mailup-bee-newsletter-modules-divider",
                                    uuid: "297f5e00-1b15-4949-bf00-8695d5f48fd5",
                                },
                                {
                                    descriptor: {
                                        computedStyle: {
                                            hideContentOnMobile: false,
                                        },
                                        style: {
                                            "padding-bottom": "10px",
                                            "padding-left": "30px",
                                            "padding-right": "30px",
                                            "padding-top": "10px",
                                        },
                                        text: {
                                            computedStyle: {
                                                linkColor: "#0015ADE8",
                                            },
                                            html: '<div class="txtTinyMce-wrapper" style="font-size: 14px; line-height: 21px; font-family: inherit;" data-mce-style="font-size: 14px; line-height: 21px; font-family: inherit;"><p style="line-height: 18px; word-break: break-word; text-align: left;" data-renderer-start-pos="8929" data-mce-style="line-height: 18px; word-break: break-word; text-align: left;"><span style="font-size: 16px; line-height: 24px;" data-mce-style="font-size: 16px; line-height: 24px;">Ongoing support from donors like you allows {{OrganizationName}} to continue making a positive impact on the world.</span></p></div>',
                                            style: {
                                                color: "#555555",
                                                "font-family": "inherit",
                                                "line-height": "150%",
                                            },
                                        },
                                    },
                                    locked: false,
                                    type: "mailup-bee-newsletter-modules-text",
                                    uuid: "f2b2e847-5b1a-4df9-8105-eccce6a3dd6e",
                                },
                            ],
                            style: {
                                "background-color": "transparent",
                                "border-bottom": "0px solid transparent",
                                "border-left": "0px solid transparent",
                                "border-right": "0px solid transparent",
                                "border-top": "0px solid transparent",
                                "padding-bottom": "20px",
                                "padding-left": "0px",
                                "padding-right": "0px",
                                "padding-top": "10px",
                            },
                            uuid: "fbbd9298-ca40-47e8-8154-f4ffbd97a9b7",
                        },
                    ],
                    container: {
                        style: {
                            "background-color": "transparent",
                            "background-image": "none",
                            "background-position": "top left",
                            "background-repeat": "no-repeat",
                        },
                    },
                    content: {
                        computedStyle: {
                            hideContentOnDesktop: false,
                            hideContentOnMobile: false,
                            rowColStackOnMobile: true,
                            rowReverseColStackOnMobile: false,
                            verticalAlign: "top",
                        },
                        style: {
                            "background-color": "transparent",
                            "background-image": "none",
                            "background-position": "top left",
                            "background-repeat": "no-repeat",
                            "border-bottom": "0px solid transparent",
                            "border-left": "0px solid transparent",
                            "border-radius": "0px",
                            "border-right": "0px solid transparent",
                            "border-top": "0px solid transparent",
                            color: "#000000",
                            width: "600px",
                        },
                    },
                    empty: false,
                    locked: false,
                    synced: false,
                    type: "one-column-empty",
                    uuid: "81604898-ee6d-46b2-8bc2-303ec123015e",
                },
                {
                    columns: [
                        {
                            "grid-columns": 12,
                            modules: [
                                {
                                    descriptor: {
                                        computedStyle: {
                                            hideContentOnMobile: false,
                                        },
                                        style: {
                                            "padding-bottom": "0px",
                                            "padding-left": "0px",
                                            "padding-right": "0px",
                                            "padding-top": "0px",
                                        },
                                        text: {
                                            computedStyle: {
                                                linkColor: "#0015ADE8",
                                            },
                                            html: '<div class="txtTinyMce-wrapper" style="font-size:14px;line-height:16px;font-family:inherit;" data-mce-style="font-size:14px;line-height:16px;font-family:inherit;"><p style="font-size:14px;line-height:16px;word-break:break-word;text-align:center;" data-mce-style="font-size:14px;line-height:16px;word-break:break-word;text-align:center;"><span style="font-size:15px;line-height:18px;" data-mce-style="font-size:15px;line-height:18px;"><strong>Organization Name</strong></span><br/><span style="font-size:15px;line-height:18px;" data-mce-style="font-size:15px;line-height:18px;">{{OrganizationName}}</span><br/><br/><span style="font-size:15px;line-height:18px;" data-mce-style="font-size:15px;line-height:18px;"><strong>Gift Amount</strong></span><br/><span style="font-size:15px;line-height:18px;" data-mce-style="font-size:15px;line-height:18px;">{{RecurringGiftAmount}}</span><br/><br/><span style="font-size:15px;line-height:18px;" data-mce-style="font-size:15px;line-height:18px;"><strong>Payment Method</strong></span><br/><span style="font-size:15px;line-height:18px;" data-mce-style="font-size:15px;line-height:18px;">{{RecurringGiftPaymentLast4}}</span><br/><br/><span style="font-size:15px;line-height:18px;" data-mce-style="font-size:15px;line-height:18px;"><strong>Frequency</strong></span><br/><span style="font-size:15px;line-height:18px;" data-mce-style="font-size:15px;line-height:18px;">{{RecurringFrequency}}</span><br/><br/><span style="font-size:15px;line-height:18px;" data-mce-style="font-size:15px;line-height:18px;"><strong>Next Charge Date</strong></span><br/><span style="font-size:15px;line-height:18px;" data-mce-style="font-size:15px;line-height:18px;">{{NextChargeDate}}</span><br/><br/><span style="font-size:15px;line-height:18px;" data-mce-style="font-size:15px;line-height:18px;"><strong>Project Allocation(s)</strong></span><br/><span style="font-size:15px;line-height:18px;" data-mce-style="font-size:15px;line-height:18px;">{{RecurringGiftProjects}}</span></p></div>',
                                            style: {
                                                color: "#6f6f6f",
                                                "font-family": "inherit",
                                                "line-height": "120%",
                                            },
                                        },
                                    },
                                    locked: false,
                                    type: "mailup-bee-newsletter-modules-text",
                                    uuid: "461bbfc6-bea4-44c2-b43b-84e2b4253f68",
                                },
                            ],
                            style: {
                                "background-color": "transparent",
                                "border-bottom": "0px solid transparent",
                                "border-left": "0px solid transparent",
                                "border-right": "0px solid transparent",
                                "border-top": "0px solid transparent",
                                "padding-bottom": "30px",
                                "padding-left": "0px",
                                "padding-right": "0px",
                                "padding-top": "25px",
                            },
                            uuid: "e682f3dd-6688-4598-a0a1-13af9e030498",
                        },
                    ],
                    container: {
                        style: {
                            "background-color": "transparent",
                            "background-image": "none",
                            "background-position": "top left",
                            "background-repeat": "no-repeat",
                        },
                    },
                    content: {
                        computedStyle: {
                            hideContentOnDesktop: false,
                            hideContentOnMobile: false,
                            rowColStackOnMobile: true,
                            rowReverseColStackOnMobile: false,
                            verticalAlign: "top",
                        },
                        style: {
                            "background-color": "#fafafa",
                            "background-image": "none",
                            "background-position": "top left",
                            "background-repeat": "no-repeat",
                            "border-bottom": "0px solid transparent",
                            "border-left": "0px solid transparent",
                            "border-radius": "20px",
                            "border-right": "0px solid transparent",
                            "border-top": "0px solid transparent",
                            color: "#000000",
                            width: "600px",
                        },
                    },
                    empty: false,
                    locked: false,
                    synced: false,
                    type: "one-column-empty",
                    uuid: "c8ac388f-0831-4338-94d1-153f1f36802c",
                },
                {
                    columns: [
                        {
                            "grid-columns": 12,
                            modules: [
                                {
                                    descriptor: {
                                        computedStyle: {
                                            align: "center",
                                            hideContentOnMobile: false,
                                        },
                                        divider: {
                                            style: {
                                                "border-top":
                                                    "1px solid #DADADA",
                                                width: "100%",
                                            },
                                        },
                                        style: {
                                            "padding-bottom": "35px",
                                            "padding-left": "0px",
                                            "padding-right": "0px",
                                            "padding-top": "45px",
                                        },
                                    },
                                    locked: false,
                                    type: "mailup-bee-newsletter-modules-divider",
                                    uuid: "e0106245-8330-4a0c-9f7b-d4411c53dd78",
                                },
                                {
                                    descriptor: {
                                        computedStyle: {
                                            hideContentOnMobile: false,
                                        },
                                        style: {
                                            "padding-bottom": "7px",
                                            "padding-left": "30px",
                                            "padding-right": "30px",
                                            "padding-top": "0px",
                                        },
                                        text: {
                                            computedStyle: {
                                                linkColor: "#0015ADE8",
                                            },
                                            html: '<div class="txtTinyMce-wrapper" style="font-size:14px;line-height:16px;font-family:inherit;" data-mce-style="font-size:14px;line-height:16px;font-family:inherit;"><p style="font-size:14px;line-height:16px;word-break:break-word;" data-mce-style="font-size:14px;line-height:16px;word-break:break-word;"><span style="font-size:18px;line-height:21px;" data-mce-style="font-size:18px;line-height:21px;">Manage Your Donation</span></p></div>',
                                            style: {
                                                color: "#333333",
                                                "font-family": "inherit",
                                                "line-height": "120%",
                                            },
                                        },
                                    },
                                    locked: false,
                                    type: "mailup-bee-newsletter-modules-text",
                                    uuid: "0f5fc75e-5576-45bf-bb21-ce483ee83a12",
                                },
                                {
                                    descriptor: {
                                        computedStyle: {
                                            hideContentOnMobile: false,
                                        },
                                        style: {
                                            "padding-bottom": "5px",
                                            "padding-left": "30px",
                                            "padding-right": "30px",
                                            "padding-top": "0px",
                                        },
                                        text: {
                                            computedStyle: {
                                                linkColor: "#0015ADE8",
                                            },
                                            html: '<div class="txtTinyMce-wrapper" style="font-size:14px;line-height:21px;font-family:inherit;" data-mce-style="font-size:14px;line-height:21px;font-family:inherit;"><p style="line-height:18px;word-break:break-word;text-align:left;" data-renderer-start-pos="9306" data-mce-style="line-height:18px;word-break:break-word;text-align:left;"><span style="font-size:15px;line-height:22px;" data-mce-style="font-size:15px;line-height:22px;">Easily update your contact information, make changes to your recurring gift, and have receipts resent to you by email.</span></p></div>',
                                            style: {
                                                color: "#555555",
                                                "font-family": "inherit",
                                                "line-height": "150%",
                                            },
                                        },
                                    },
                                    locked: false,
                                    type: "mailup-bee-newsletter-modules-text",
                                    uuid: "76b82fa5-629d-409d-b000-4ad155f02827",
                                },
                                {
                                    descriptor: {
                                        button: {
                                            href: "{{DonorPortalLogin}}",
                                            label: '<div class="txtTinyMce-wrapper" style="" data-mce-style=""><p style="word-break:break-word;" data-mce-style="word-break:break-word;">Donor Portal Login</p></div>',
                                            style: {
                                                "background-color": "#333333",
                                                "border-bottom":
                                                    "0px solid transparent",
                                                "border-left":
                                                    "0px solid transparent",
                                                "border-radius": "30px",
                                                "border-right":
                                                    "0px solid transparent",
                                                "border-top":
                                                    "0px solid transparent",
                                                color: "#FFFFFF",
                                                direction: "ltr",
                                                "font-family": "inherit",
                                                "font-size": "15px",
                                                "font-weight": "400",
                                                "line-height": "200%",
                                                "max-width": "100%",
                                                "padding-bottom": "5px",
                                                "padding-left": "35px",
                                                "padding-right": "35px",
                                                "padding-top": "5px",
                                                width: "auto",
                                            },
                                            target: "_blank",
                                        },
                                        computedStyle: {
                                            height: 40,
                                            hideContentOnMobile: false,
                                            width: 196,
                                        },
                                        style: {
                                            "padding-bottom": "10px",
                                            "padding-left": "30px",
                                            "padding-right": "30px",
                                            "padding-top": "10px",
                                            "text-align": "left",
                                        },
                                    },
                                    locked: false,
                                    type: "mailup-bee-newsletter-modules-button",
                                    uuid: "88cee5a1-c8e0-4f31-9d31-0789e0f6b597",
                                },
                                {
                                    descriptor: {
                                        computedStyle: {
                                            align: "center",
                                            hideContentOnMobile: false,
                                        },
                                        divider: {
                                            style: {
                                                "border-top":
                                                    "1px solid #DADADA",
                                                width: "100%",
                                            },
                                        },
                                        style: {
                                            "padding-bottom": "25px",
                                            "padding-left": "0px",
                                            "padding-right": "0px",
                                            "padding-top": "35px",
                                        },
                                    },
                                    locked: false,
                                    type: "mailup-bee-newsletter-modules-divider",
                                    uuid: "ca3f3408-90c9-45e8-8ac6-3cadcd0ef979",
                                },
                            ],
                            style: {
                                "background-color": "transparent",
                                "border-bottom": "0 solid transparent",
                                "border-left": "0 solid transparent",
                                "border-right": "0 solid transparent",
                                "border-top": "0 solid transparent",
                                "padding-bottom": "5px",
                                "padding-left": "0px",
                                "padding-right": "0px",
                                "padding-top": "5px",
                            },
                            uuid: "de6e5770-f804-49e1-b9ef-bea405585617",
                        },
                    ],
                    container: {
                        style: {
                            "background-color": "transparent",
                            "background-image": "none",
                            "background-position": "top left",
                            "background-repeat": "no-repeat",
                        },
                    },
                    content: {
                        computedStyle: {
                            hideContentOnDesktop: false,
                            hideContentOnMobile: false,
                            rowColStackOnMobile: true,
                            rowReverseColStackOnMobile: false,
                            verticalAlign: "top",
                        },
                        style: {
                            "background-color": "transparent",
                            "background-image": "none",
                            "background-position": "top left",
                            "background-repeat": "no-repeat",
                            color: "#000000",
                            width: "600px",
                        },
                    },
                    empty: false,
                    locked: false,
                    synced: false,
                    type: "one-column-empty",
                    uuid: "d12fff76-0df2-4e48-bf89-235a60941227",
                },
            ],
            template: {
                version: "2.0.0",
            },
            title: "",
        },
        comments: {},
    };
};
